module.exports = __webpack_public_path__ + "static/media/Trust.acdcb7db.png";